import { defineComponent } from "vue";
import SummaryBox from "../components/SummaryBox";

export default defineComponent({
    components: {
        SummaryBox,
    },

    template: `
        <div class="OrderLayout">
            <div class="OrderLayout__wrap">
                <div v-if="title" class="OrderLayout__title title-1" v-html="title"></div>

                <div class="wrapper" :class="[ 'wrapper--' + wrapper ]">
                    <div class="OrderLayout__inner">
                        <div class="OrderLayout__summary">
                            <SummaryBox
                                :options="options"
                                :step="step"
                                :collapsed="summarycollapsed"

                                :visible_usage="!['offers.upload', 'noinvoice.calcform'].includes(options.step) || options.documents?.length > 0"

                                @offer:change="$emit('offer:change')"
                            />
                        </div>

                        <div class="OrderLayout__body">
                            <slot></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    `,

    emits: [
        'offer:change',
    ],

    props: {
        options: { type: Object, required: true },

        step: { type: Number },
        title: { type: String },

        wrapper: { type: Number, default: 990 },

        summarycollapsed: { type: Boolean, default: true },
    },

    mounted() {
        $('body').addClass('body--OrderLayout');
    },

    unmounted() {
        $('body').removeClass('body--OrderLayout');
    },
});
